<template>
    <div
        class="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
        @click.stop.prevent="openFileUploadDialog($event)"
    >
        <file-upload-default-view
            v-if="viewToRender === 'default'"
            @open-file-upload-dialog="openFileUploadDialog($event)"
            @open-g-drive-dialog="openGdriveDialog"
            @open-drop-box-dialog="openDropboxDialog"
            @toggle-drop-down="toggleDropdown"
            :disable-g-drive-button="disableGdriveButton"
            :showDropdown="showDropdown"
            :start-clicked="startClicked"
            @startClicked="startClicked = true"
        ></file-upload-default-view>
        <upload-in-progress-view
            v-if="viewToRender === 'upload-in-progress'"
            @open-file-upload-dialog="openFileUploadDialog($event)"
            @open-g-drive-dialog="openGdriveDialog"
            @open-drop-box-dialog="openDropboxDialog"
            @toggle-drop-down="toggleDropdown"
            :disable-g-drive-button="disableGdriveButton"
            :showDropdown="showDropdown"
            :start-clicked="startClicked"
            @startClicked="startClicked = true"
        ></upload-in-progress-view>
        <add-file-view
            v-if="viewToRender === 'add-file'"
            @open-file-upload-dialog="openFileUploadDialog($event)"
            @open-g-drive-dialog="openGdriveDialog"
            @open-drop-box-dialog="openDropboxDialog"
            @toggle-drop-down="toggleDropdown"
            :disable-g-drive-button="disableGdriveButton"
            :showDropdown="showDropdown"
            :start-clicked="startClicked"
            @startClicked="startClicked = true"
        ></add-file-view>
        <file-added-view
            @open-file-upload-dialog="openFileUploadDialog($event)"
            @open-g-drive-dialog="openGdriveDialog"
            @open-drop-box-dialog="openDropboxDialog"
            @toggle-drop-down="toggleDropdown"
            :disable-g-drive-button="disableGdriveButton"
            :showDropdown="showDropdown"
            :start-clicked="startClicked"
            @startClicked="startClicked = true"
            v-if="viewToRender === 'file-added'"
        ></file-added-view>
        <waiting-for-upload-view v-if="viewToRender === 'waiting-for-upload'" :files="files"></waiting-for-upload-view>
    </div>
</template>

<script>
import FileUploadDefaultView from './file-upload-views/FileUploadDefaultView.vue';
import UploadInProgressView from './file-upload-views/UploadInProgressView.vue';
import AddFileView from './file-upload-views/AddFileView.vue';
import FileAddedView from './file-upload-views/FileAddedView.vue';
import WaitingForUploadView from './file-upload-views/WaitingForUploadView.vue';
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { getGlobalUploader } from '../../global-uploader';
import { pageNotification } from '../../../../qaamgo/helper/notify';
import { globalLogger } from '../../../../qaamgo/helper/global-logger';
import { satGlobals } from '../../../../qaamgo/sat/helper/sat-globals';
import { eventBus } from '../../../../lib/event-bus/event-bus';
import { UPLOADER_EVENT } from '../../core/event';
import {
    INPUT_STATUS_UPLOADER_DONE,
    INPUT_STATUS_UPLOADER_LOADING,
    INPUT_STATUS_UPLOADER_QUEUED,
    INPUT_STATUS_UPLOADER_SUBMITTING,
} from '../../core/consts';
import { translate } from '../../../../qaamgo/helper/translate';
import UploadProgressManager from '../upload-progress-manager';

export default {
    components: { FileUploadDefaultView, UploadInProgressView, AddFileView, FileAddedView, WaitingForUploadView },
    name: 'FileUploadView',
    mixins: [TransFilter],
    mounted() {
        document.addEventListener('click', this.closeDropdown);

        document.querySelectorAll('.submit-btn').forEach((btn) => {
            btn.addEventListener('click', () => {
                this.startClicked = true;
                if (this.isUploading === true) {
                    this.clickedStartWhileloading = true;
                }
            });
        });

        eventBus.listen(UPLOADER_EVENT, (uploaderEvent) => {
            const inputs = window.qgUploader.getInputList()?._inputs;
            this.handleUploaderStatus(uploaderEvent, inputs);
        });
    },
    data() {
        return {
            showDropdown: false,
            disableGdriveButton: false,
            isUploading: false,
            filesUploaded: [],
            clickedStartWhileloading: false,
            startClicked: false,
            progressPercent: 0,
            files: [],
        };
    },
    methods: {
        openDropboxDialog() {
            this.closeDropdown();
            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('openDropboxDialog - no uploader defined');

                return;
            }

            uploader.clickDropBox();
        },
        openGdriveDialog(event) {
            this.closeDropdown();
            if (this.disableGdriveButton) return;
            this.disableGdriveButton = true;
            setTimeout(() => (this.disableGdriveButton = false), 1000);
            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('openGdriveDialog - no uploader defined');

                return;
            }

            uploader.clickGdrive();
        },
        openFileUploadDialog(e) {
            if (e.target.className.includes('add-example-file')) {
                window.qgUploader.addExternalUrl(window.pageConfig.example_file);
                return;
            }
            if (e.target.className.includes('submit-button')) {
                if (this.isUploading) {
                    this.clickedStartWhileloading = true;
                }
                window.qgFeaturePage.defaultSubmit();
                return;
            }
            this.closeDropdown();
            const uploader = getGlobalUploader();

            if (uploader === null) {
                pageNotification.error('Something went wrong, please try again later!');
                globalLogger.log('openFileUploadDialog - no uploader defined');

                return;
            }

            uploader.clickFileUpload();
        },
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        closeDropdown() {
            this.showDropdown = false;
        },
        handleUploaderStatus(uploaderEvent, inputs) {
            this.files = UploadProgressManager.getUploadFilesProgress(
                uploaderEvent.event,
                uploaderEvent.localId,
                uploaderEvent.data
            );

            if (inputs.length > 0) {
                this.filesUploaded = inputs.filter((input) => input._status === INPUT_STATUS_UPLOADER_DONE);
                let loading = true;
                for (let i = 0; i < inputs.length; i++) {
                    if (
                        inputs[i]._status === INPUT_STATUS_UPLOADER_QUEUED ||
                        inputs[i]._status === INPUT_STATUS_UPLOADER_SUBMITTING ||
                        inputs[i]._status === INPUT_STATUS_UPLOADER_LOADING
                    ) {
                        loading = true;
                        break;
                    } else {
                        loading = false;
                    }
                }
                if (loading) {
                    this.isUploading = true;
                } else {
                    this.isUploading = false;
                    if (this.clickedStartWhileloading) {
                        window.qgFeaturePage.defaultSubmit();
                    }
                    this.clickedStartWhileloading = false;
                }
            }
        },
    },
    computed: {
        darkText() {
            if (window.pageConfig.uploaderTextColor) {
                return window.pageConfig.uploaderTextColor;
            }
        },

        viewToRender() {
            if (this.startClicked && this.filesUploaded.length < 1 && !this.isUploading) {
                this.startClicked = false;
                return 'add-file';
            }
            if (this.isUploading && this.startClicked) {
                return 'waiting-for-upload';
            }
            if (this.isUploading) {
                return 'upload-in-progress';
            }
            if (this.filesUploaded.length > 0) {
                return 'file-added';
            }
            return 'default';
        },
    },
};
</script>
<style scoped lang="scss">
.dropdown-item.active,
.dropdown-item:active {
    color: #2e2e2e;
    background-color: #f5f5f5;
}
.dropdown-item:focus,
.dropdown-item:hover {
    color: #2e2e2e;
    background-color: #f5f5f5;
}
#feature-upload-icon-spinner {
    position: absolute;
    margin-top: 30px;
    margin-left: 45px;
}

.btn-group {
    @media (max-width: 470px) {
        width: 100%;
        justify-content: center;
        padding: 0 10px;
    }
    button {
        @media (max-width: 470px) {
            justify-content: center;
            z-index: 1000000;
        }
    }
}
</style>
